(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card"] && !Shopify.designMode) return;
  try {
    (() => {
  const initCards = (root) => {

    const cards = root.querySelectorAll('.collection-card');

    cards.forEach((card) => {

      if (card.dataset.auraTouchReady === 'true') return;

      const flip = card.querySelector('.aura-category-flip');

      if (!flip) return;

      card.dataset.auraTouchReady = 'true';

      let timer = null;
      let startX = 0;
      let startY = 0;
      let activated = false;

      const clearTimer = () => {

        if (timer) {
          clearTimeout(timer);
          timer = null;
        }

      };


      card.addEventListener(
        'touchstart',
        (event) => {

          if (!event.touches.length) return;

          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;

          activated = false;

          clearTimer();

          timer = setTimeout(() => {

            flip.classList.add(
              'aura-category-flip--active'
            );

            activated = true;

          }, 60);

        },
        { passive: true }
      );


      card.addEventListener(
        'touchmove',
        (event) => {

          if (!event.touches.length) return;

          const moveX = Math.abs(
            event.touches[0].clientX - startX
          );

          const moveY = Math.abs(
            event.touches[0].clientY - startY
          );

          if (
            !activated &&
            (moveX > 10 || moveY > 10)
          ) {
            clearTimer();
          }

        },
        { passive: true }
      );


      card.addEventListener(
        'touchend',
        () => {

          clearTimer();

          setTimeout(() => {

            flip.classList.remove(
              'aura-category-flip--active'
            );

          }, activated ? 320 : 0);

        },
        { passive: true }
      );


      card.addEventListener(
        'touchcancel',
        () => {

          clearTimer();

          flip.classList.remove(
            'aura-category-flip--active'
          );

        },
        { passive: true }
      );

    });

    };
  initCards(document);
  document.addEventListener('shopify:section:load', (event) => initCards(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {

  if (window.AuraProductTouchInstalled) return;

  window.AuraProductTouchInstalled = true;


  const touchDevice =
    window.matchMedia(
      '(hover: none) and (pointer: coarse)'
    );


  if (!touchDevice.matches) return;


  let activeCard = null;

  let startX = 0;
  let startY = 0;



  function resetCard(card) {

    if (!card) return;


    card.classList.remove(
      'aura-card-touching'
    );


    card.classList.add(
      'aura-card-releasing'
    );


    card.style.setProperty(
      '--aura-touch-x',
      '0px'
    );


    card.style.setProperty(
      '--aura-touch-y',
      '0px'
    );


    card.style.setProperty(
      '--aura-touch-rotate',
      '0deg'
    );


    window.setTimeout(() => {

      card.classList.remove(
        'aura-card-releasing'
      );

    }, 430);

  }



  document.addEventListener(
    'touchstart',
    (event) => {

      if (
        event.target.closest(
          '.buy-buttons-block'
        )
      ) {
        return;
      }


      const card =
        event.target.closest(
          '.aura-product-card'
        );


      if (!card) return;


      activeCard = card;


      const touch =
        event.touches[0];


      startX =
        touch.clientX;


      startY =
        touch.clientY;


      card.classList.remove(
        'aura-card-releasing'
      );


      card.classList.add(
        'aura-card-touching'
      );

    },
    { passive: true }
  );



  document.addEventListener(
    'touchmove',
    (event) => {

      if (!activeCard) return;


      const touch =
        event.touches[0];


      const deltaX =
        touch.clientX - startX;


      const deltaY =
        touch.clientY - startY;



      /*
        If user clearly starts vertical scrolling,
        stop the card movement.
      */

      if (
        Math.abs(deltaY) > 12 &&
        Math.abs(deltaY) > Math.abs(deltaX)
      ) {

        resetCard(activeCard);

        activeCard = null;

        return;
      }



      const moveX =
        Math.max(
          -4,
          Math.min(
            4,
            deltaX * 0.08
          )
        );


      const moveY =
        Math.max(
          -3,
          Math.min(
            3,
            deltaY * 0.06
          )
        );


      const rotate =
        Math.max(
          -0.8,
          Math.min(
            0.8,
            deltaX * 0.015
          )
        );


      activeCard.style.setProperty(
        '--aura-touch-x',
        `${moveX}px`
      );


      activeCard.style.setProperty(
        '--aura-touch-y',
        `${moveY}px`
      );


      activeCard.style.setProperty(
        '--aura-touch-rotate',
        `${rotate}deg`
      );

    },
    { passive: true }
  );



  document.addEventListener(
    'touchend',
    () => {

      if (!activeCard) return;


      resetCard(activeCard);


      activeCard = null;

    },
    { passive: true }
  );



  document.addEventListener(
    'touchcancel',
    () => {

      if (!activeCard) return;


      resetCard(activeCard);


      activeCard = null;

    },
    { passive: true }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
